import { getById } from 'common/builder/selectors/managerSelectors'
import { setDraftSuccess } from 'common/flow/actions/flowActions'
import * as API from 'constants/API'
import { getClientId } from 'utils/clientId'

export const setFlowDraft = (managerId, patch, coordinates) => {
  return async (dispatch, getState) => {
    const manager = getById(getState(), managerId)

    if (!manager || !manager.flowId) {
      return
    }

    await dispatch({
      $fetch: [
        API.flow.endpoints.setFlowDraft,
        {
          method: 'POST',
          body: JSON.stringify({
            ns: manager.flowId,
            batch: patch,
            coordinates,
            client_id: getClientId(),
          }),
          headers: { 'Content-Type': 'application/json' },
        },
      ],
    })

    dispatch(setDraftSuccess(manager.flowId))
  }
}
